import { makeStyles, Theme, createStyles, Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

type TableLoaderProps = {
  limit: number;
};

export const TableLoadingState = ({ limit }: TableLoaderProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.headerRow}>
        <Skeleton width={58} height={16} />
        <Skeleton width={80} height={16} />
        <Skeleton width={80} height={16} />
        <Skeleton width={80} height={16} />
        <Skeleton width={80} height={16} />
        <Skeleton width={80} height={16} />
        <Skeleton width={80} height={16} />
      </Box>
      {Array.from(Array(limit ?? 10).keys()).map((idx) => (
        <Box className={classes.tableRow} key={idx}>
          <Skeleton width={119} height={16} style={{ margin: "16px 0" }} />
          <Skeleton width={58} height={16} style={{ margin: "16px 0" }} />
          <Skeleton width={80} height={16} style={{ margin: "16px 0" }} />
          <Skeleton width={58} height={16} style={{ margin: "16px 0" }} />
          <Skeleton width={58} height={16} style={{ margin: "16px 0" }} />
          <Skeleton width={172} height={16} style={{ margin: "16px 0" }} />
          <Skeleton width={80} height={16} style={{ margin: "16px 0" }} />
        </Box>
      ))}
      <Box className={classes.pagination}>
        <Skeleton width={94} height={16} style={{ marginRight: "16px" }} />
        <Skeleton
          variant="rect"
          width={32}
          height={32}
          style={{ marginRight: "40px", borderRadius: 2 }}
        />
        <Skeleton width={69} height={16} style={{ marginRight: "21px" }} />
        <Skeleton
          variant="rect"
          width={32}
          height={32}
          style={{ marginRight: "16px", borderRadius: 2 }}
        />
        <Skeleton variant="rect" width={32} height={32} style={{ borderRadius: 2 }} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: 4,
      boxShadow: "0 1px 1px 0 rgba(32, 37, 43, 0.12), 0 0 1px 0 rgba(32, 37, 43, 0.1)",
      backgroundColor: "white",
    },
    headerRow: {
      width: "100%",
      height: 48,
      borderRadius: 4,
      boxShadow: "0 1px 0 0 #f7f7f7",
      backgroundColor: "white",
      display: "flex",
      justifyContent: "space-between",
      margin: 0,
      padding: `${theme.spacing(2)}px`,
    },
    tableRow: {
      display: "flex",
      justifyContent: "space-between",
      backgroundColor: "white",
      padding: `0 ${theme.spacing(2)}px`,
      marginLeft: 0,
      "&:nth-of-type(even)": {
        backgroundColor: "#fafbfc",
      },
      "&:nth-of-type(odd)": {
        backgroundColor: "white",
      },
    },
    pagination: {
      height: 48,
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      padding: `0 ${theme.spacing(2)}px`,
    },
  }),
);
